import { t } from '@/lib/i18n/messages.js';
import { cn } from '@/lib/utils.js';

interface WidgetErrorProps {
  errorCode?: string | undefined;
  errorMessage?: string | undefined;
  requestId?: string | undefined;
  className?: string | undefined;
}

export function WidgetError({ errorCode, errorMessage, requestId, className }: WidgetErrorProps) {
  return (
    <div
      className={cn(
        'rounded-[var(--radius-card)] border border-red-800/50',
        'bg-red-950/20 p-4',
        className,
      )}
      role="alert"
      data-testid="widget-error"
    >
      <p className="mb-1 text-sm font-semibold text-red-400">
        {t('dashboards.widget_error_title')}
      </p>
      {errorCode !== undefined && (
        <p className="font-mono text-xs text-[var(--color-qup-text-muted-dark)]">{errorCode}</p>
      )}
      {errorMessage !== undefined && (
        <p className="mt-1 text-xs text-[var(--color-qup-text-muted-dark)]">{errorMessage}</p>
      )}
      {requestId !== undefined && (
        <p className="mt-2 font-mono text-xs text-[var(--color-qup-text-muted-dark)] opacity-60">
          req: {requestId}
        </p>
      )}
    </div>
  );
}
